import React, { useState, useEffect } from 'react';
import { FaLinkedin, FaTwitter, FaInstagram, FaFacebook } from 'react-icons/fa';
import { getPageContent } from '../../services/pageService';

const Footer: React.FC = () => {
  const [phone, setPhone] = useState('+91 77950 06081');
  const [email, setEmail] = useState('shreegurucool@gmail.com');

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const contactData = await getPageContent('contact');
        if (contactData) {
          if (contactData.phone) setPhone(contactData.phone);
          if (contactData.email) setEmail(contactData.email);
        }
      } catch (err) {
        // Silently fallback to defaults on error
        console.error('Failed to load contact info in footer:', err);
      }
    };
    fetchContactInfo();
  }, []);

  return (
    <footer className="bg-gray-900 text-white py-8">
      <div className="max-w-5xl mx-auto px-4 flex flex-col items-center text-center space-y-6">
        
        {/* Logo + Tagline */}
        <div>
          <img src="/logo.jpeg" alt="ShreeGuruCool Logo" className="h-16 mx-auto mb-2 rounded-lg shadow-md" />
          <p className="text-gray-300 text-base font-medium">
            ShreeGuruCool Teknologies<br></br>
            Empowering SAP Learning – Where Traditional Guidance Meets Digital Freedom.
          </p>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-lg font-semibold mb-2">Contact Us</h3>
          <p className="text-sm text-gray-400">
            Email: <a href={`mailto:${email}`} className="text-white hover:underline">{email}</a>
          </p>
          <p className="text-sm text-gray-400">
            Phone: <a href={`tel:${phone.replace(/\s+/g, '')}`} className="text-white hover:underline">{phone}</a>
          </p>
        </div>

        {/* Social Media Icons */}
        <div>
          <h3 className="text-lg font-semibold mb-2">Follow Us</h3>
          <div className="flex justify-center space-x-6 text-gray-400 text-xl">
            <a
              href="https://in.linkedin.com/in/%F0%9F%8F%9D%EF%B8%8Fshreegurucool%F0%9F%93%9A-teknologies-208080248"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-500"
              aria-label="LinkedIn"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://twitter.com/shreegurucool"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-sky-400"
              aria-label="Twitter"
            >
              <FaTwitter />
            </a>
            <a
              href="https://www.instagram.com/shreegurucool/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-pink-500"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.facebook.com/people/Shree-Gurucool/100087966021724/?_rdr"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-600"
              aria-label="Facebook"
            >
              <FaFacebook />
            </a>
          </div>
        </div>

        {/* Divider */}
        <hr className="w-full border-t border-gray-700" />

        {/* Copyright */}
        <div className="text-xs text-gray-500">
          <p>&copy; 2024 ShreeGuruCool Technologies. All rights reserved.</p>
          <p>Developed by <span className="text-white font-medium"><a href="https://poornatejareddy.vercel.app/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-600" style={{color: "cyan"}}>Poorna Teja Reddy K</a></span></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
